import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../services/api/resources";
import classes from "./VendorsTab.module.css";

const VendorVerificationTable = () => {
  const loginData = useSelector((state) => state.loginData.value);
  const buyer_token = loginData?.user?.token;

  const [companyLogs, setCompanyLogs] = useState([]);

  const fetchVendorVerificationLogs = async () => {
    try {
      const response = await axios.post(
        API_ENDPOINT.get_vendor_verification_logs,
        {
          buyer_token: buyer_token,
        }
      );
      setCompanyLogs(response.data);
    } catch (error) {
      console.error("Error fetching logs:", error);
    }
  };

  const tableStyles = {
    headerCell: {
      fontWeight: "bold",
      fontSize: "14px",
      backgroundColor: "#f5f5f5",
      color: "#333",
    },
    bodyCell: {
      fontSize: "15px",
      color: "#444",
    },
    row: {
      "&:hover": {
        backgroundColor: "#f0f0f0",
      },
    },
    container: {
      borderRadius: "5px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
  };

  useEffect(() => {
    fetchVendorVerificationLogs();
  }, []);

  return (
    <>
      <HeaderTitle titleText={"KYC Re-Verification Analysis"} />

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {companyLogs &&
          companyLogs.map((company, index) => (
            <div className={classes.divShadow}>
              <Accordion key={index} defaultExpanded={false}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  style={{ borderBottom: "1px solid #e9e9e9" }}
                >
                  <p className={classes.accordionHeader}>
                    <span>Company: {company.company_name}</span>
                  </p>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper} sx={tableStyles.container}>
                    <Table>
                      <TableHead>
                        <TableRow
                          sx={{ textOverflow: "hidden", whiteSpace: "nowrap" }}
                        >
                          <TableCell sx={tableStyles.headerCell}>
                            Sl. No.
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            Verified On
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            Overall Status
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            PAN Status
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            GST Status
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            Bank Status
                          </TableCell>
                          <TableCell sx={tableStyles.headerCell}>
                            Message
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {company.logs.length > 0 ? (
                          company.logs.map((log) => (
                            <TableRow key={log.id} sx={tableStyles.row}>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.id}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {new Date(log.verified_on).toLocaleDateString()}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.overall_status}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.pan_status}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.gst_status}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.bank_status}
                              </TableCell>
                              <TableCell sx={tableStyles.bodyCell}>
                                {log.message}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={7}
                              align="center"
                              sx={{ color: "#999", fontStyle: "italic", py: 2 }}
                            >
                              No data found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
      </div>
    </>
  );
};

export default VendorVerificationTable;
